import React from "react";
import { Tabs, Typography, Card } from "antd";
import { CriminalAlbumLog } from "./criminalAlbumLog";

const { Title } = Typography;
const { TabPane } = Tabs;

export const Logs = () => {
  return (
    <Card title="Logs">
      <div style={{ padding: "20px" }}>
        {/* Tabs */}

        <Tabs defaultActiveKey="1">
          <TabPane tab="Album Log" key="1">
            <CriminalAlbumLog />
          </TabPane>
        </Tabs>
      </div>
    </Card>
  );
};
